import React from 'react';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import constants from '../../utils/constants';
import { ThemeProvider } from '@mui/material/styles';

const index = ({ value, className, mode, disabled, id, name, help, onChange, design, view, mandatory }) => {

  const handleChange = (event) => {
    onChange(event);
  };

  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <TextField
          disabled={disabled}
          key={id}
          id={id}
          label={design !== 'table' ? <span>
            {name}
            {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
          </span> : null}
          type={(view === 'r' || view === 'd') && value ? "time" : (view !== 'r' && view !== 'd') && !disabled ? "time" : (view !== 'r' && view !== 'd') && disabled && value ? "time" : ""}
          className={className ?? undefined}
          InputLabelProps={{
            height: '1px',
            shrink: true,
            style: { fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }
          }}
          value={value}
          onChange={handleChange}
          inputProps={{ readOnly: mode, style: { height: '1px', fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" } }}
        />
      </Tooltip>
    </ThemeProvider>
  );
};

export default index;
